import { useEffect, useState } from "react";
import useRefetchOnFocus from "../../hooks/useRefetchOnFocus";
import { useNavigate } from "react-router-dom";
import { useOwnerLayout } from "./OwnerLayout";
import useGetProjects from "../../hooks/useGetProjects";
import ProjectCardSkeleton from "../../Components/Common/Skeleton/ProjectCardSkeleton";
import Pagination from "../../Components/Common/Pagination/Pagination";
import CommercialIcon from "Assets/Img/CommercialIcon";
import ResidentialIcon from "Assets/Img/ResidentialIcon";
import "./OwnerDashboard.scss";
import { formatStatus } from "Pages/GcPrecon/GcProjectDetails/components/DrawHistoryTable";
import NetworkError from "Components/Common/NetworkError/NetworkError";
import EmptyState from "Components/Common/EmptyState/EmptyState";
import EmptyProjectsIcon from "Assets/Img/EmptyProjectsIcon";

const PAGE_SIZE = 10;

export default function OwnerDashboard() {
  const navigate = useNavigate();
  const { setCrumbs } = useOwnerLayout();
  const [page, setPage] = useState(1);
  const { projects, pagination, loading, error, refetch } = useGetProjects(
    page,
    PAGE_SIZE,
  );

  useRefetchOnFocus(refetch);

  useEffect(() => {
    setCrumbs([{ label: "My Projects" }]);
  }, []);

  return (
    <div className="gcDashboard">
      <div className="dashLayout">
        <div className="dashHeader">
          <div className="w-100">
            <h1>My Projects</h1>
            <p>
              {loading ? (
                " "
              ) : pagination.total > 0 ? (
                `${pagination.total} project${pagination.total > 1 ? "s" : ""} assigned to you.`
              ) : (
                <div className="mt-5">
                  <EmptyState
                    height={"500px"}
                    icon={<EmptyProjectsIcon />}
                    title={"No Projects Yet"}
                    subtitle={
                      "Projects added to the platform will appear here once they are created."
                    }
                  />
                </div>
              )}
            </p>
          </div>
        </div>

        {error && <NetworkError />}

        {loading && (
          <>
            <div className="sectionLabel">Loading</div>
            {Array.from({ length: PAGE_SIZE }).map((_, i) => (
              <ProjectCardSkeleton key={i} />
            ))}
          </>
        )}

        {!loading && !error && projects.length > 0 && (
          <>
            <div className="sectionLabel">Projects</div>
            {projects.map((project) => (
              <div
                key={project.id}
                className="projectCard"
                onClick={() => navigate(`/owner-project-detail/${project.id}`)}
              >
                <div className="pcThumb">
                  {project.type === "commercial" ? (
                    <CommercialIcon />
                  ) : (
                    <ResidentialIcon />
                  )}
                </div>
                <div className="pcInfo">
                  <div className="pcName">{project.name}</div>
                  <div className="pcMeta">
                    {project.bank && <>{project.bank} · </>}
                    {project.type.charAt(0).toUpperCase() +
                      project.type.slice(1)}
                  </div>
                </div>
                <div className="pcStatus">
                  <span className="badge badgeGreen">
                    <span className="badgeDot"></span>
                    {formatStatus(project.status)}
                  </span>
                </div>
              </div>
            ))}
          </>
        )}

        {pagination.totalPages > 1 && (
          <Pagination
            currentPage={page}
            totalPages={pagination.totalPages}
            total={pagination.total}
            limit={PAGE_SIZE}
            onPageChange={setPage}
          />
        )}
      </div>
    </div>
  );
}
